import { useCurrentPageName } from './useCurrentPageName';

export const useMetricBase = () => {
    const source = useCurrentPageName();

    return `services.${source}_perseus`;
};
